












































































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { GetUserInfo } from '../api/login/index';
import { GetTools, GetToolUrl } from '../api/common/index';
import { QueryFiles } from '../api/space/index';
import { AccountModule } from '@/store/modules/account';
import { Route } from 'vue-router';
import { downloadByUrl } from '@/utils/file.util';

@Component
export default class Index extends Vue {
  @Watch('$route', { immediate: true })
  onRouterChange(to: Route) {
    this.getUserInfo();
  }
  regards = '早上好';
  async mounted() {
    await this.getUserInfo();
    await this.getTools();
    await this.getFilelist();
    const hour = new Date().getHours();
    this.regards = hour < 8 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 18 ? '下午好' : '晚上好';
  }

  currentToolIndex = 0;
  toolList = [];
  async getTools() {
    GetTools({ isIndex: true }).then(res => {
      this.toolList = res.subToolClassifyList[0].subToolClassifyList;
      this.workList = res.subToolClassifyList[1].subToolClassifyList;
    });
  }

  handleWorkNav(item: any) {
    if (item.isOuterUrl) {
      window.open(item.url, '_blank');
    } else {
      this.$router.push(item.url);
      // this.$message.warning('暂未开发');
    }
  }

  handleTool(index: number) {
    this.currentToolIndex = index;
  }

  dialogVerify = false;
  toolCode = '';
  toolVerify = '';

  handleToolNav(item: any) {
    if (item.isOuterUrl) {
      GetToolUrl({ toolCode: item.code, verify: '' }).then(res => {
        if (res.code == 0) {
          window.open(res.url, '_blank');
        } else if (res.code == 900061) {
          this.toolCode = item.code;
          this.dialogVerify = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    } else {
      this.$router.push(item.url);
    }
  }

  confirmToolNav() {
    if (!this.toolVerify) {
      return this.$message.warning('请填写验证码');
    }
    GetToolUrl({ toolCode: this.toolCode, verify: this.toolVerify }).then(res => {
      if (res.code == 0) {
        this.dialogVerify = false;
        window.open(res.url, '_blank');
      } else {
        this.$message.error(res.msg);
      }
    });
  }

  closeDialog() {
    this.dialogVerify = false;
  }
  /**
   * 获取用户信息
   */
  userInfo = {};
  async getUserInfo() {
    GetUserInfo().then(res => {
      this.userInfo = res;
      AccountModule.setUserInfo(res);
    });
  }

  recentFileList = [];
  /**
   * 获取最近文件
   */
  async getFilelist() {
    QueryFiles({ queryType: 0 }).then(res => {
      this.recentFileList = res.splice(0, 4);
    });
  }

  handleDownloadFile(url: string, name: string) {
    downloadByUrl(url, name);
  }

  handleCheckFile(item: any) {
    if (['.png', '.jpeg', '.jpg', '.pdf'].includes(item.fileType)) {
      window.open(item.url, '_blank');
    } else {
      window.open(`https://view.officeapps.live.com/op/view.aspx?src=${item.url}`, '_blank');
    }
  }

  toCanva() {
    window.open('https://tiaofutong.hnqsmz.com', '_blank', 'noopener,noreferrer');
  }

  toSpace() {
    this.$router.push('/space');
  }

  toYqy() {
    window.open('http://gongfudou.com/yiqiyin.html', '_blank');
  }

  toQxb() {
    window.open(' https://www.qixin.com/', '_blank');
  }

  workList = [];
}
